export default "__VITE_ASSET__M5Z5mA45__"